module.exports = __webpack_public_path__ + "img/activity.d72219c5.png";